import { ResolveFn, Routes } from '@angular/router';
import { ConfirmacaoVagaComponent } from './confirmacao-vaga.component';
import { Role } from '../../core/enums/role.enum';
import { RoleGuard } from '../../guard/auth-guard/role.guard';
import { UsuarioResponseDto } from '../../shared/models/response/usuario-response.model';
import { UsuarioService } from '../../shared/services/usuario.service';
import { inject } from '@angular/core';

const resolver: ResolveFn<UsuarioResponseDto> = (route, state) => {
  var usuarioService = inject(UsuarioService);

  return usuarioService.current();
};

export const confirmacaoVagaRoutes: Routes = [
  {
    path: 'confirmacao-vaga',
    component: ConfirmacaoVagaComponent,
    canActivate: [RoleGuard],
    data: {
      title: 'Confirmação de Vaga',
      breadcrumb: [{ label: 'Início', url: '/' }],
      roles: [Role.CONFIRMAR_VAGA],
    },
    resolve: {
      usuario: resolver,
    },
  },
];
